import { Container, Row, Col, Image } from 'react-bootstrap';
import PageHero from '../components/PageHero';

export default function Location() {

  const certificates = [
    {
      src: '/cert/unesco20creative20city-eng.jpg',
      alt: 'Certificate 1',
    },
    {
      src: '/cert/european_green_capital.jpg',
      alt: 'Certificate 2',
    },
    {
      src: '/cert/TOP_100_Logo_2021.png',
      alt: 'Certificate 3',
    },
    {
      src: '/cert/SLO_destination_platinum.png',
      alt: 'Certificate 4',
    },
    {
      src: '/cert/EBD_Ljubljana.png',
      alt: 'Certificate 5',
    },
  ];  

  const thingsToDo = [
    {
      icon: 'bi-signpost-split',
      title: 'Old Town walk',
      text: 'Explore Prešernov trg Square, Triple Bridge, Dragon Bridge and Town Hall.',
    },
    {
      icon: 'bi-bank',
      title: (
        <a href="https://www.ljubljanskigrad.si/en/" target="_blank" rel="noreferrer">
          Ljubljana castle
        </a>
      ),
      text: 'Take the funicular or walk up to the top for panoramic views over the city.',
    },
    {
      icon: 'bi-basket',
      title: 'Central Market',
      text: 'Discover local food, flowers and Slovenian specialities in the city centre.',
    },
    {
      icon: 'bi-cup-hot',
      title: (
        <a href="https://www.odprtakuhna.si/" target="_blank" rel="noreferrer">
          Odprta kuhna
        </a>
      ),
      text: 'Visit the popular open-air Friday food market at Pogačarjev trg Square.',
    },
    {
      icon: 'bi-tree',
      title: 'Tivoli Park',
      text: 'Take a short break in Ljubljana’s largest and most beautiful green space.',
    },
    {
      icon: 'bi-bicycle',
      title: (
        <a href="https://www.bicikelj.si/en/home" target="_blank" rel="noreferrer">
          BicikeLJ
        </a>
      ),
      text: 'Use the city bicycle-sharing system to explore the wider city area.',
    },
    {
      icon: 'bi-water',
      title: 'Ljubljanica boat tour',
      text: 'Experience the city from the river with a relaxed boat ride.',
    },
    {
      icon: 'bi-palette',
      title: 'Metelkova mesto',
      text: 'Discover Ljubljana’s alternative cultural quarter and street-art scene.',
    },
    {
      icon: 'bi-image',
      title: 'Museums and galleries',
      text: 'Visit the National Gallery, Museum of Modern Art, City Museum or Plečnik House.',
    },
  ];



  return (
    <>
      <PageHero
        eyebrow="Participant info"
        title="Location"
        intro="Ljubljana is a compact, walkable capital where history, culture, food and green spaces are all within easy reach."
      />

      <main className="info-page py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} xl={9}>
              <section className="info-section">
                <h2 className='h1 mt-5'>A green capital of a green country</h2>
                <p>
                  Ljubljana is a city where a thousand years of history is compressed into a perfectly walkable, car-free centre. Its true charm for a visitor with limited time lies in its <span class="text-marker">incredible density of experiences;</span> within a few blocks, you can transition from the quiet Baroque elegance of the riverside to the raw, kaleidoscopic energy of the Metelkova art district.
                </p>
                <figure className="info-photo d-none">
                  <Image
                    src="/F013104-dozivetja_v_ljubljani_in_okolici_22_andrej_tarfila-photo-m.jpg"
                    alt="Cankarjev dom congress centre"
                    fluid
                  />

                  <figcaption>
                    <i className="bi bi-arrow-right-short" aria-hidden="true"></i>
                    <span>River Ljubljanica and the vibrant city centre (Foto by Andrej Tarfila).</span>
                  </figcaption>
                </figure>

                <div className="video-frame my-4">
                  <div className="ratio ratio-16x9 overflow-hidden rounded">
                    <iframe
                      src="https://www.youtube.com/embed/rAIzUuy_b6A"
                      title="Ljubljana"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
                <p>
                  In a single afternoon, it is entirely possible to take the glass funicular up to the medieval castle for an Alpine panorama, cross the dragon-guarded bridges, and dive into a vibrant street-art scene. Whether you are seeking a moment of peace in Tivoli Park or a lively encounter in a riverside café, <span class="text-marker">the city’s effortless diversity</span> ensures that even the shortest stroll feels like a complete journey.
                </p>
                <Row className="certificate-strip row-cols-2 row-cols-md-3 row-cols-lg-5 g-3">
                {certificates.map((certificate) => (
                  <Col key={certificate.src}>
                    <div className="certificate-card">
                      <Image
                        src={certificate.src}
                        alt={certificate.alt}
                        fluid
                      />
                    </div>
                  </Col>
                ))}
              </Row>
              </section>

             

              


              <section className="info-section">
                <h2>Things to do nearby</h2>

                <Row className="g-3 mt-4">
                  {thingsToDo.map((item) => (
                    <Col md={6} lg={4} key={item.title}>
                      <div className="thing-card">
                        <div className="thing-card-icon">
                          <i className={`bi ${item.icon}`} aria-hidden="true"></i>
                        </div>

                        <div>
                          <h3>{item.title}</h3>
                          <p>{item.text}</p>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>

                <p className='mt-5'>
                  Only few people in history have left such a powerful mark on their city as the architect{' '}
                  <a
                    href="https://www.visitljubljana.com/en/visitors/sights-and-activities/plecniks-ljubljana"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Jože Plečnik left on Ljubljana
                  </a>
                  . Plečnik&apos;s Ljubljana has been included in UNESCO World Heritage List.
                </p>

                 <figure className="info-photo mb-0">
                <Image
                  src="img/F013107-dozivetja_v_ljubljani_in_okolici_25_andrej_tarfila-photo-m.jpg"
                  alt="Tromostovje"
                  fluid
                />

                <figcaption>
                  <i className="bi bi-arrow-right-short" aria-hidden="true"></i>
                  <span>City centre with triple bridge and view toward Ljubljana castle (photo by Andrej Tarfila).</span>
                </figcaption>
              </figure>

              <p className="info-note">
                <strong>Tip for adventurists:</strong> Discover the legacy of the{' '}
                <a
                  href="https://www.space-invaders.com/about/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Invader
                </a>{' '}
                who attacked Ljubljana twice.
              </p>

              <p className="info-note info-note--bottle">
                  <strong>Bring your water bottle with you!</strong>{' '}
                  Ljubljana is very proud of its exceptional tap water, and there are more
                  than 50 public drinking fountains across the city.
              </p>

              
              </section>

              
              
              <section className="info-section">
                <h2>Food & restaurants</h2>
                <ul className="info-list">
                  <li>Try local Slovenian dishes such as kranjska klobasa (traditional Slovenian pork sausage), potica (Slovenian rolled nut cake), prekmurska gibanica (traditional layered pastry from Prekmurje), štruklji (rolled dumplings with various fillings) and kraški pršut (dry-cured ham from the Karst region).</li>
                  <li>For traditional or local cuisine, consider Slovenska Hiša – Figovec, Gostilna na Gradu, Gostilna As, Restaurant Šestica, Klobasarna, Moji štruklji Slovenije, Špajza, Restavracija Julija and Restavracija Strelec.</li>
                  <li>If you are a foodie, check the{' '}<a
                      href="https://guide.michelin.com/en/si/central-slovenia/ljubljana/restaurants"
                      target="_blank"
                      rel="noreferrer"
                    >Michelin Guide recommended restaurants.</a></li>
                  <li>
                    Participants interested in food and culture can also join the{' '}
                    <a
                      href="https://www.visitljubljana.com/en/visitors/tours-and-trips/taste-ljubljana-food-tour/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Taste Ljubljana Food Tour
                    </a>
                    .
                  </li>
                  <li>
                    Don’t miss{' '}
                    <a href="https://www.odprtakuhna.si/" target="_blank" rel="noreferrer">
                      Odprta kuhna
                    </a>{' '}
                    — the open-air Friday food market with local and international stalls.
                  </li>
                </ul>

                <figure className="info-photo">
                  <Image
                    src="img/F008801-odprta_kuhna_jost_gantar_16_orig_jpg-photo-m.jpg"
                    alt="Odprta kuhna"
                    fluid
                  />

                  <figcaption>
                    <i className="bi bi-arrow-right-short" aria-hidden="true"></i>
                    <span>Odprta kuhna street food event (photo by Jošt Gantar).</span>
                  </figcaption>
                </figure>

                <p className="info-note info-note--alert">
                  <strong>Tip:</strong> Ljubljana’s centre is very walkable, but restaurants can be busy in the evening, so advance reservations are recommended for group dinners.
                </p>
              </section>

              

              <section className="info-section">
                <h2>Bars & evening drinks</h2>
                <ul className="info-list">
                  <li>Enjoy a relaxed drink at one of the open-air cafés or bars along the Ljubljanica River.</li>
                  <li>For wine, suggested options include Dvorni Bar, Vinoteka Dvor, Vinoteka Movia, Vinoteka Dekanter, Kletvica Wine Bar and Vinoteka Štorija.</li>
                  <li>For beer, participants can try Pivnica Union, Lajbah Craft Beer Bar, Sir William’s Pub, Craft Room, Tektonik Brewery, :Projekt Beershop & Bar or Holidays Pub.</li>
                </ul>
                <p className='mt-3'>
                  For more suggestions on sightseeing, restaurants, cafés, bars, cultural
                  experiences, and practical visitor information, participants can also refer
                  to the <a href="https://www.slideshare.net/slideshow/ljubljana-touristguide/104352029"
                    target="_blank" rel="noreferrer" >official Ljubljana Tourist Guide brochure</a> and the <a  href="https://www.visitljubljana.com/assets/Dokumenti-PDF/Tiskovine-EN/3-Day-Travel-Itinerary-Explore-Ljubljana.pdf" target="_blank" rel="noreferrer" > suggested 3-day Ljubljana itinerary.</a>
                </p>
              </section>

              <section className="info-section">
                <h2>Beyond the Dragon’s Gate: Exploring Slovenia</h2>
                <p>
                  Beyond the capital, Slovenia’s landscape shifts <span class="text-marker">from the Julian Alps to the Adriatic coast in less than two hours</span> without traffic jams. </p>
                  
                  <p>Lake Bled offers the country’s most recognizable scenery, featuring a glacial lake with a central island and a cliffside castle. 
                  Further south, the Postojna Caves provide access to vast limestone passages, while the coastal town of Piran reflects a distinct Venetian influence. Whether visiting the emerald waters of the Soča Valley or the seaside, the country’s compact geography allows for a wide range of environments to be reached within a single day. This accessibility ensures that even a brief excursion beyond the city provides a comprehensive view of the region’s natural and architectural diversity.
                </p>
                <figure className="info-photo">
                <Image
                  src="img/F013546-bled_alex_strohl-photo-m.jpg"
                  alt="Bled"
                  fluid
                />

                <figcaption>
                  <i className="bi bi-arrow-right-short" aria-hidden="true"></i>
                  <span>Bled with its island (photo by Alex Strohl).</span>
                </figcaption>
              </figure>
              </section>
              

            </Col>
          </Row>
        </Container>
      </main>

    </>
  );
}
